// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/turn-performance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/turn-performance/turn-radius.js';

mount([g0]);
